import { SystemCode, SystemCodeToJSON } from '@/api'

export interface ForwardingRequest {
  userId: string
  bibliographyId: number
  forwardingRequestLevel: SystemCode
  forwardingRequestMemo: string
  forwardingRequestBranch: SystemCode[]
  reserveMethod: string
  reserveSpecifyBranch: SystemCode[]
  specifyCollectionId: number
  specifyCollectionNo: string
  reserveRegistrationBranchCode: SystemCode
  reserveRegistrationPlaceCode: SystemCode
  forwardingBranchCode: SystemCode
  forwardingPlaceCode: SystemCode
  reserveRegistrationDate: string
  preferredDate: string
  reserveNoticeAllowed: boolean
  contactMethod: SystemCode
  displayMemo: string
  _forceRequest: boolean
  requestReserve: boolean
}

export function ForwardingRequestRequestToJSON(value: ForwardingRequest): any {
  return {
    user_id: value.userId,
    bibliography_id: value.bibliographyId,
    forwarding_request_level: SystemCodeToJSON(value.forwardingRequestLevel)
      .code,
    forwarding_request_memo: value.forwardingRequestMemo,
    forwarding_request_branch_codes: value.forwardingRequestBranch.map(
      item => item.code
    ),
    reserve_method: value.reserveMethod,
    reserve_specify_branch_codes:
      value.reserveSpecifyBranch.length > 0
        ? value.reserveSpecifyBranch.map(item => item.code)
        : undefined,
    specify_collection_id:
      value.specifyCollectionId !== 0 ? value.specifyCollectionId : undefined,
    specify_collection_no:
      value.specifyCollectionNo !== '' ? value.specifyCollectionNo : undefined,
    reserve_registration_branch_code: value.reserveRegistrationBranchCode.code,
    reserve_registration_place_code: value.reserveRegistrationPlaceCode.code,
    forwarding_branch_code: value.forwardingBranchCode.code,
    forwarding_place_code: value.forwardingPlaceCode.code,
    reserve_registration_date: value.reserveRegistrationDate,
    preferred_date: value.preferredDate,
    reserve_notice_allowed: value.reserveNoticeAllowed,
    contact_method: value.contactMethod.code,
    display_memo: value.displayMemo,
    _force_request: value._forceRequest,
    request_reserve: value.requestReserve
  }
}
